/**
 * This class is an event handler that will only execute the last callback that is set.
 * A callback that is set with a timeout delay can be overwritten by another callback that has been set before the first callback has been executed.
 */
export default class ExclusiveDelayedCallbackHandler {
  private lastTimeoutId: number = -1;

  constructor() {}

  setTimeout(callback: () => void, delay: number = 0) {
    if (this.lastTimeoutId >= 0) {
      clearTimeout(this.lastTimeoutId);
    }
    this.lastTimeoutId = setTimeout(() => {
      callback();
      this.lastTimeoutId = -1;
    }, delay);
  }

  get isWaiting() {
    return this.lastTimeoutId >= 0;
  }
}